// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CR5jf","swiper":"styles_swiper__WaHQl","slide":"styles_slide__DNoTH","slideLink":"styles_slideLink__xIL5r"};